module.exports = __webpack_public_path__ + "img/packages/h6.36af18.png";